import React from "react";
import PropTypes from 'prop-types'
import { makeStyles } from "@material-ui/core/styles";
import grey from "@material-ui/core/colors/grey";
import TypographyTitle from "../../../components/TypographyTitle";
import TypographyParagraph from "../../../components/TypographyParagraph";

const useStyles = makeStyles((theme) => ({
  row: {
    paddingTop: 208,
    display: "flex",
    justifyContent: "center",
    height: "100vh",
  },
  column: {
    paddingLeft: theme.spacing(3),
  },
  oops: {
    margin: `${theme.spacing(3.5, 0, 2, 0)} !important`,
    fontSize: 18,
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },
  heading: {
    margin: theme.spacing(2, 0, 3, 0),
    width: 330,
    color: grey[800],
  },
  text: {
    fontSize: 16,
  },
}));

function SummaryReportEmptyState(props) {
  const { type = 'noAccess' } = props;
  const classes = useStyles();

  const mainHeading = type === 'noAccess' ? 'Oops.' : 'Attention.';
  const subHeading = type === 'noAccess' ? 'Looks like you don\'t have access to any Survey Reports.' : 'There is no report available for this work setting.';
  const bodyText = type === 'noAccess' ? 'Please contact your Survey Lead for more information.' : 'This report is suppressed due to insufficient responses.';

  return (
    <div className={classes.row}>
      <div className={classes.column}>
        <img src="/blocked-sign.svg" alt="blocked" />
      </div>
      <div className={classes.column}>
        <TypographyParagraph className={classes.oops}>{mainHeading}</TypographyParagraph>
        <TypographyTitle className={classes.heading}>{subHeading}</TypographyTitle>
        <TypographyParagraph className={classes.text}>{bodyText}</TypographyParagraph>
      </div>
    </div>
  );
}

SummaryReportEmptyState.propTypes = {
  /** If noAccess then the user signed in via SSO and has no access to reports, if noReport then the unit selected had fewer than 5 respondents */
  type: PropTypes.oneOf(['noAccess', 'noReport']),
};

export default SummaryReportEmptyState;



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/SummaryReportEmptyState.jsx